import { Icon12Stars, Icon16Stars } from '@vkontakte/icons';
import { Button, classNames, Spacing } from '@vkontakte/vkui';
import { HoverPopper } from '@vkontakte/vkui/dist/components/HoverPopper/HoverPopper';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import type { EStorageType } from 'reactApp/modules/storage/storage.types';
import { sendDwh } from 'reactApp/utils/ga';

import styles from './AiPhotoImprovingTooltip.css';

interface AiPhotoImprovingTooltipProps {
    size?: 20 | 24 | 28 | 32;
    hasBorder?: boolean;
    onPhotoImprovingOpen?: (event: any) => void;
}

const sendRadar = (action: 'show' | 'click' | 'close', place: EStorageType) => {
    sendDwh({
        eventCategory: 'tooltip',
        action,
        dwh_enabled: true,
        dwhData: { name: 'mnz_ai_improve_tooltip_home', place },
    });
};

const aiIconClickHandler = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
};

export const AiPhotoImprovingTooltip: React.FC<AiPhotoImprovingTooltipProps> = ({ size, hasBorder, onPhotoImprovingOpen }) => {
    const storage = useSelector(getCurrentStorage);

    const onButtonClickHandler = useCallback(
        (e: React.MouseEvent, place: EStorageType) => {
            e.stopPropagation();
            sendRadar('click', place);
            onPhotoImprovingOpen?.(e);
        },
        [onPhotoImprovingOpen]
    );

    // Если по какой-то причине не прокинули колбэк на открытие файла - не показываем
    if (!onPhotoImprovingOpen) {
        return null;
    }

    return (
        <HoverPopper
            arrow
            arrowClassName={styles.arrow}
            content={
                <div className={styles.tooltip}>
                    <span className={styles.title}>Улучшайте качество фото с&nbsp;нейросетью</span>
                    <Spacing size={4} />
                    <span>Уберёт шум, добавит контрастности и&nbsp;поможет передать момент</span>
                    <Spacing size={12} />
                    <Button
                        size="l"
                        mode="primary"
                        appearance="accent"
                        className={styles.button}
                        onClick={(e) => {
                            onButtonClickHandler(e, storage);
                        }}
                    >
                        Попробовать
                    </Button>
                </div>
            }
            onShownChange={(shown) => {
                sendRadar(shown ? 'show' : 'close', storage);
            }}
        >
            <div
                className={classNames(styles.aiIcon, {
                    [styles.aiIcon24]: size === 24,
                    [styles.aiIcon28]: size === 28,
                    [styles.aiIcon32]: size === 32,
                    [styles.aiIconBorder]: hasBorder,
                })}
                onClick={aiIconClickHandler}
            >
                {size === 32 || size === 28 ? (
                    <Icon16Stars fill="var(--vkui--color_text_contrast)" />
                ) : (
                    <Icon12Stars fill="var(--vkui--color_text_contrast)" />
                )}
            </div>
        </HoverPopper>
    );
};
